module.exports = __webpack_public_path__ + "img/img-managed-automation-new.08c4f68c.svg";